import * as React from 'react';
import { connect } from 'react-redux';
import { resolveDataSync, resolveData, onDataUpdate } from '../DynamicData';
import { allComponentsAreResolved, resolveComponentAndChildComponents } from '../resolve-component';
class DynamicData extends React.Component {
    constructor(props) {
        super(props);
        this.unbindDataWacher = null;
        this.resolveComponents = (data, currentTheme) => {
            if (!allComponentsAreResolved(data)) {
                if (this.state.componentsResolved !== false) {
                    this.setState({ componentsResolved: false });
                }
                return resolveComponentAndChildComponents(data, currentTheme).then(() => {
                    this.setState({ componentsResolved: true });
                }, () => {
                    this.setState({ resolveFailed: true, componentsResolved: false });
                });
            }
            else if (this.state.componentsResolved !== true) {
                this.setState({ componentsResolved: true });
            }
        };
        this.resolveData = (data) => {
            return resolveData(data).then(d => {
                if (this.state.resolveFailed) {
                    this.setState({ resolveFailed: false });
                }
                return this.resolveComponents(d, this.props.currentTheme);
            }, e => {
                this.setState({ resolveFailed: true });
            });
        };
        const data = resolveDataSync(props.data);
        let componentsResolved = false;
        if (data !== null) {
            componentsResolved = allComponentsAreResolved(data, props.currentTheme);
        }
        this.state = {
            resolveFailed: false,
            componentsResolved,
        };
    }
    componentDidMount() {
        if (this.props.shouldResolve !== false) {
            const syncData = resolveDataSync(this.props.data);
            if (syncData === null) {
                this.resolveData(this.props.data);
            }
            else {
                this.resolveComponents(syncData, this.props.currentTheme);
            }
        }
        this.unbindDataWacher = onDataUpdate(this.props.data, () => this.forceUpdate());
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            if (this.unbindDataWacher) {
                this.unbindDataWacher();
            }
            this.unbindDataWacher = onDataUpdate(nextProps.data, () => this.forceUpdate());
        }
        if (nextProps.shouldResolve !== false) {
            const nextData = resolveDataSync(nextProps.data);
            if (nextData === null) {
                this.resolveData(nextProps.data);
            }
            else {
                this.resolveComponents(nextData, nextProps.currentTheme);
            }
        }
    }
    componentWillUnmount() {
        if (this.unbindDataWacher) {
            this.unbindDataWacher();
        }
    }
    render() {
        const loadedData = resolveDataSync(this.props.data);
        if (loadedData && this.state.componentsResolved) {
            return this.props.children(loadedData);
        }
        if (this.state.resolveFailed) {
            if (this.props.onError) {
                return this.props.onError(() => this.resolveData(this.props.data));
            }
            else {
                return null;
            }
        }
        if (this.props.fallbackData) {
            return this.props.children(this.props.fallbackData);
        }
        return this.props.fallback || null;
    }
}
export default connect((state) => ({
    currentTheme: state.currentTheme,
}))(DynamicData);
